import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Field } from "react-final-form";
import { isValidEmail } from "../../../support/field-parsers";

const EmailField = ({ id, labelPlacement, label, placeholder, isRequired }) => {
  return (
    <Field
      name={`id_${id}`}
      type="email"
      validate={(values) => {
        if (isRequired && !values) {
          return "Required";
        }
        if (values && !isValidEmail(values)) {
          return "Enter Valid Email Address";
        }
      }}
    >
      {({ input, meta }) => (
        <FormControl isInvalid={meta.error && meta.touched} position="relative">
          {labelPlacement !== "HIDDEN" ? (
            <FormLabel htmlFor={id}>{label}</FormLabel>
          ) : null}
          <Input bg="white" {...input} placeholder={placeholder} />
          {meta.error && meta.touched && !meta.active && (
            <FormErrorMessage
              fontSize="14px"
              bg="red.500"
              color="white"
              position="absolute"
              left="0"
              right="0"
              top="100%"
              mt="0"
              px={2}
              rounded="5"
              fontWeight="bold"
            >
              {meta.error}
            </FormErrorMessage>
          )}
        </FormControl>
      )}
    </Field>
  );
};

export default EmailField;
